module.exports = __webpack_public_path__ + "static/media/KE.d5fc32a7.png";